export default async function getPreregistros(repository) {
  return repository.getPersonas();
}
